import { DEV, PREPROD, PROD, QA } from "./env";

export const featureToggles = {
  ftProspectLaunch: [DEV, QA, PREPROD, PROD],
  ftReadableUrlPaths:  [DEV, QA, PREPROD, PROD],
  ftConnectPage:  [DEV, QA, PREPROD, PROD],
  ftLegalDisclaimer: [DEV, QA, PREPROD, PROD],
  ftSendEmailToNewUser: [DEV, QA, PREPROD, PROD],
  ftDashboard: [DEV, QA, PREPROD, PROD],
  ftAppProgressPage: [DEV, QA, PREPROD, PROD],
  ftUseSSEinFDMConsole: [DEV, QA, PREPROD, PROD],
};
